import { useEffect, useState } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { CAISO_CMRI_VIEW } from '../../interface';
import { CmriOverviewView } from './view';

export function CmriView() {
    const [view, setView] = useState<CAISO_CMRI_VIEW>(CAISO_CMRI_VIEW.OVERVIEW);
    const navigate = useNavigate();
    const location = useLocation();

    const handleView = (newView: CAISO_CMRI_VIEW) => {
        setView(newView);
    };

    useEffect(() => {
        if (location.pathname === '/caiso/cmri' || location.pathname === '/caiso/cmri/') {
            navigate('/caiso/cmri/overview');
        }
    }, [location.pathname, navigate]);

    return (
        <>
            <Routes>
                <Route path="overview" element={<CmriOverviewView view={view} handleView={handleView} />} />
            </Routes>
        </>
    );
}
